import CONSTANTS from './constants.js'

const reducer = (state = CONSTANTS.DEFAULT_STATE,action) => {
    let returnObj = Object.assign({},state);
    
    switch(action.type){
        case CONSTANTS.ACTIONS.START_STOP_PRESSED:
            returnObj = startStopCase(returnObj);
            break;
        
        case CONSTANTS.ACTIONS.TIMER_ACTIVE:
            returnObj = timerActiveCase(returnObj);
            break;
            
        case CONSTANTS.ACTIONS.TIMER_ID:
            returnObj = setTimerIDcase(returnObj,action.timerID);
            break;
            
        case CONSTANTS.ACTIONS.SESSION_L:
            returnObj = setSessionLcase(returnObj,action.adjustTimer);
            break;
            
        case CONSTANTS.ACTIONS.BREAK_L:
            returnObj = setBreakLcase(returnObj,action.adjustTimer);
            break;
            
        case CONSTANTS.ACTIONS.RESET:
            returnObj = resetCase(returnObj);
            break;
    }
    
    return returnObj;
}

//cases
function startStopCase(state){
    let returnObj = Object.assign({},state);
    
    //toggle timer
    returnObj.timerActive = !returnObj.timerActive;
    
    //turn timer off if timer is disabled
    if(!returnObj.timerActive){
        clearInterval(returnObj.timerID);
    }
    
    return returnObj;
}

//controls the countdown of the timer
function timerActiveCase(state){
    let returnObj = Object.assign({},state);
    
    
    //Call function to handle sessions if the session timer is still the active one
    if(returnObj.sessionTimerActive){
        returnObj = sessionController(returnObj);
    }else{
        returnObj = breakController(returnObj);  
    }

    
    
    
    //functions
    //This handles the session branch
    function sessionController(state){
        let returnObj = Object.assign({},state);
        
        //Only countdown if the timer is active
        if(returnObj.timerActive){
            //stop the timer at 00:00
            if(returnObj.currentM == '00' && returnObj.currentS == '00'){
                //play audio file at 00:00
                document.getElementById(returnObj.audioID).play();
                
                if(returnObj.breakL > 9){
                    returnObj.currentM = returnObj.breakL;
                }else{
                    returnObj.currentM = '0' + returnObj.breakL;
                }
                returnObj.displayString = 'Break';
                
                returnObj.sessionTimerActive = false;   //timer has reached 00:00
            }
            else{
                if(returnObj.currentS == '00'){
                    returnObj.currentS = '59';
                    returnObj.currentM--;
                    returnObj.currentM = returnObj.currentM.toString();

                    if(returnObj.currentM < 10 && returnObj.currentM >= 0){
                        returnObj.currentM = '0' + returnObj.currentM;
                    }
                }else{    
                    if(returnObj.currentS > 0 && returnObj.currentS <= 59){
                        returnObj.currentS--;
                        returnObj.currentS = returnObj.currentS.toString();

                        if(returnObj.currentS >= 0 && returnObj.currentS < 10){
                            returnObj.currentS = '0' + returnObj.currentS;
                        }
                    }
                }
            }
        }
        return returnObj;
    }
    
    function breakController(state){
        let returnObj = Object.assign({},state);
    
        //Only countdown if the timer is active
        if(returnObj.timerActive){
            //stop the timer at 00:00
            if(returnObj.currentM == '00' && returnObj.currentS == '00'){
                //play audio file at 00:00
                document.getElementById(returnObj.audioID).play();
                
               if(returnObj.sessionL > 9){
                    returnObj.currentM = returnObj.sessionL;
                }else{
                    returnObj.currentM = '0' + returnObj.sessionL;
                }
                returnObj.displayString = 'Session';
                returnObj.sessionTimerActive = true;   //Break timer has reached 00:00
            }
            else{
                if(returnObj.currentS == '00'){
                    returnObj.currentS = '59';
                    returnObj.currentM--;
                    returnObj.currentM = returnObj.currentM.toString();

                    if(returnObj.currentM < 10 && returnObj.currentM >= 0){
                        returnObj.currentM = '0' + returnObj.currentM;
                    }
                }else{    
                    if(returnObj.currentS > 0 && returnObj.currentS <= 59){
                        returnObj.currentS--;
                        returnObj.currentS = returnObj.currentS.toString();

                        if(returnObj.currentS >= 0 && returnObj.currentS < 10){
                            returnObj.currentS = '0' + returnObj.currentS;
                        }
                    }
                }
            }
        }
    
        return returnObj;
    }
    return returnObj;
}

function setTimerIDcase(state,timerID){
    let returnObj = Object.assign({},state);
    
    returnObj.timerID = timerID;
    return returnObj;
}

function setSessionLcase(state,adjustTimer){
    let returnObj = Object.assign({},state);
    
    //only allow timer to be adjusted if timer is deactived
    if(!returnObj.timerActive){
        if(adjustTimer == CONSTANTS.ACTIONS.INCREMENT_TIMER){
            returnObj = incrementTimer(returnObj);
            //reset timer seconds
            returnObj.currentS = CONSTANTS.DEFAULT_STATE.currentS;
        }else{
            if(adjustTimer == CONSTANTS.ACTIONS.DECREMENT_TIMER){
                returnObj = decrementTimer(returnObj);
                //reset timer seconds
                returnObj.currentS = CONSTANTS.DEFAULT_STATE.currentS;
            }
        }
    }
    
    //functions to handle increment and decrement
    function incrementTimer(state){
        let returnObj = Object.assign({},state);
        
        if(returnObj.sessionL < 60){
            returnObj.sessionL++;
            returnObj.currentM = returnObj.sessionL;
            
            if(returnObj.currentM > 0 && returnObj.currentM < 10){
                returnObj.currentM = '0' + returnObj.currentM; 
            }
        }
        
        
        
        return returnObj;
    }
    
    function decrementTimer(state){
        let returnObj = Object.assign({},state);
        
        if(returnObj.sessionL > 1){
            returnObj.sessionL--;
            returnObj.currentM = returnObj.sessionL;
            
            if(returnObj.currentM > 0 && returnObj.currentM < 10){
                returnObj.currentM = '0' + returnObj.currentM; 
            }
        }
        
        
        
        return returnObj;
    }
    
    return returnObj;
}

function setBreakLcase(state,adjustTimer){
    let returnObj = Object.assign({},state);
    
    //only allow timer to be adjusted if timer is deactived
    if(!returnObj.timerActive){
        if(adjustTimer == CONSTANTS.ACTIONS.INCREMENT_TIMER){
            returnObj = incrementTimer(returnObj);
        }else{
            if(adjustTimer == CONSTANTS.ACTIONS.DECREMENT_TIMER){
                returnObj = decrementTimer(returnObj);
            }
        }
    }
    
    //functions to handle increment and decrement
    function incrementTimer(state){
        let returnObj = Object.assign({},state);
        
        if(returnObj.breakL < 60){
            returnObj.breakL++;
        }
        
        return returnObj;
    }
    
    function decrementTimer(state){
        let returnObj = Object.assign({},state);
        
        if(returnObj.breakL > 1){
            returnObj.breakL--;
        }
        
        return returnObj;
    }
    
    return returnObj;
}

function resetCase(state){
    let returnObj = Object.assign({},state);
    
    //stop any running timers
    if(returnObj.timerActive){
        clearInterval(returnObj.timerID);
    }
    
    //stop anyplaying beep and reset
    let audio = document.getElementById(returnObj.audioID);
    audio.pause();
    audio.currentTime = 0;
    
    //reset state
    returnObj = Object.assign({},CONSTANTS.DEFAULT_STATE);
    
    return returnObj;
}


export default reducer;